<div class="switch switch-default" *ngIf='valid'>
    <input #option1Input (change)="onSwitchChange()" type="radio" class="switch-input" name="toggle-switch" value="{{option1}}" id="{{option1}}-1" checked/>
    <label for="{{option1}}-1" class="switch-label switch-label-off">
        <ng-content select="[option1]"></ng-content>
    </label>

    <input #option2Input (change)="onSwitchChange()" type="radio" class="switch-input" name="toggle-switch" value="{{option2}}" id="{{option2}}-2" />
    <label for="{{option2}}-2" class="switch-label switch-label-on">
        <ng-content select="[option2]"></ng-content>
    </label>

    <span class="switch-selection"></span>
</div>
